module.exports = __webpack_public_path__ + "img/geren.2b307131.png";